import { useEffect } from 'react'
import AlertDialog from 'baby-ui/compounds/AlertDialog'
import { Box, Typography } from '@material-ui/core'
import Image from 'components/image'
import GetPumpThroughInsuranceModalActions from '../GetPumpThroughInsuranceModalActions/GetPumpThroughInsuranceModalActions'
import { BLHealthModal } from './BLHealthModal'
import {
  ADD_CART_TEXT,
  ADD_TO_CART_BODY_TEXT,
  ADD_TO_REGISTRY_BODY_TEXT,
  ADD_TO_REGISTRY_TEXT,
  BABYLIST_HEALTH_ICON,
  ORDER_THROUGH_INSURANCE_TEXT,
  SEE_PRICES_TEXT,
} from './GetPumpThroughInsuranceModal.constants'

export interface GetPumpThroughInsuranceModalProps {
  open: boolean
  onClose(): void
  onProceedWithAction(): void
  modal: BLHealthModal
  onView: () => void
  onClick: (ctaText: string) => void
}

const GetPumpThroughInsuranceModal = ({
  open,
  modal,
  onClose,
  onProceedWithAction,
  onView,
  onClick,
}: GetPumpThroughInsuranceModalProps) => {
  const alternativeActionLabel =
    modal === BLHealthModal.AddToCart ? ADD_CART_TEXT : ADD_TO_REGISTRY_TEXT
  const babylistHealthButtonLabel =
    modal === BLHealthModal.AddToCart
      ? ORDER_THROUGH_INSURANCE_TEXT
      : SEE_PRICES_TEXT
  const bodyText =
    modal === BLHealthModal.AddToCart
      ? ADD_TO_CART_BODY_TEXT
      : ADD_TO_REGISTRY_BODY_TEXT

  useEffect(() => {
    if (modal) {
      onView?.()
    }
  }, [modal])

  if (!modal) {
    return null
  }

  return (
    <AlertDialog
      open={open}
      title="Did you know that insurance will help cover the cost of your breast pump?"
      onClose={onClose}
    >
      <Box display="flex" justifyContent="center">
        <Image alt="Babylist Health" height={200} src={BABYLIST_HEALTH_ICON} />
      </Box>
      <Box display="flex" justifyContent="center" mb={4} mt={2}>
        <Typography color="textSecondary" component="p" variant="body1">
          {bodyText}
        </Typography>
      </Box>
      <GetPumpThroughInsuranceModalActions
        alternativeActionLabel={alternativeActionLabel}
        babylistHealthButtonLabel={babylistHealthButtonLabel}
        onActionClick={onClick}
        onProceedWithAction={onProceedWithAction}
      />
    </AlertDialog>
  )
}
export default GetPumpThroughInsuranceModal
